import { useTranslation } from '../../i18n';
import React, { useEffect } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

const CyclingPhysiologicalAnalysis = ({ completed = {}, metrics = {}, athleteId, activityId, banister, date }) => {
  const { t } = useTranslation();
  useEffect(() => {
    if (!completed || Object.keys(completed).length === 0) return;

    const root = am5.Root.new("chartdiv-cycling");
    root.setThemes([am5themes_Animated.new(root)]);

    const chart = root.container.children.push(
      am5xy.XYChart.new(root, {
        layout: root.verticalLayout
      })
    );

    // ✅ Habilitar cursor para mostrar tooltips
    chart.set("cursor", am5xy.XYCursor.new(root, {
      behavior: "none",
      xAxis: null,
      yAxis: null
    }));

    const xAxis = chart.xAxes.push(
      am5xy.CategoryAxis.new(root, {
        categoryField: "category",
        renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 30 }),
        tooltip: am5.Tooltip.new(root, {})
      })
    );

    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        renderer: am5xy.AxisRendererY.new(root, {})
      })
    );

    const series = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "valor",
        xAxis: xAxis,
        yAxis: yAxis,
        valueYField: "value",
        categoryXField: "category",
        tooltip: am5.Tooltip.new(root, {
          labelText: "{categoryX}: {valueY.formatNumber('#.00')}"
        })
      })
    );

    series.columns.template.setAll({
      tooltipY: 0,
      interactive: true,
      cornerRadiusTL: 6,
      cornerRadiusTR: 6,
      fill: am5.color(0x27aae1),
      stroke: am5.color(0x193255)
    });

    const parseNumber = (value) => {
      const parsed = parseFloat(value);
      return !isNaN(parsed) ? parsed : 0;
    };

    const data = [
      { category: "TSS", value: parseNumber(completed.tss) },
      { category: "IF", value: parseNumber(completed.intensityFactor) },
      { category: "NP", value: parseNumber(completed.normalizedPower) },
      { category: "VO₂ max", value: parseNumber(completed.vo2max) },
      { category: "W/kg", value: parseNumber(completed.wKg) }
    ];

    xAxis.data.setAll(data);
    series.data.setAll(data);

    return () => {
      root.dispose();
    };
  }, [completed]);

  const format = (val, fixed = 2) =>
    !isNaN(val) ? Number(val).toFixed(fixed) : 'N/A';

  const np = parseFloat(completed.normalizedPower);
  const vo2 = parseFloat(completed.vo2max);
  const tss = parseFloat(completed.tss);
  const durationMin = completed.duracion
    ? (parseFloat(completed.duracion) / 60).toFixed(2)
    : 'N/A';

  return (
    <div className="mt-4">
      <h5 style={{ fontSize: 14, fontWeight: 700, color: '#193255' }}>&#128202; {t('athleteDashboard.runningPhysio.title')}</h5>
      {vo2 && <p>{t('athleteDashboard.runningPhysio.vo2Sentence', { value: format(vo2) })}</p>}
      <p>{t('athleteDashboard.runningPhysio.tssSentence', { tss: format(tss), duration: durationMin, load: tss >= 100 ? t('athleteDashboard.runningPhysio.loadHigh') : t('athleteDashboard.runningPhysio.loadModerate') })}</p>
      {metrics?.ritmo_cardiaco?.avg && <p>{t('athleteDashboard.runningPhysio.hrSentence', { avg: metrics.ritmo_cardiaco.avg, max: metrics.ritmo_cardiaco.max })}</p>}
      {np > 0 && <p>{t('athleteDashboard.runningPhysio.npSentence', { value: format(np) })}</p>}
      <div className="mt-4">
        <h6 style={{ fontSize: 14, fontWeight: 700, color: '#193255' }}>📈 {t('athleteDashboard.runningPhysio.chartTitle')}</h6>
        <div id="chartdiv-cycling" style={{ width: "100%", height: "400px" }}></div>
      </div>


    </div>
  );
};

export default CyclingPhysiologicalAnalysis;